import { SVGProps } from 'react';

const Goal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 13V2l8 4-8 4m8.561.222a9 9 0 1 1-12.55-5.29m-.009 5.065a5 5 0 1 0 8.9 2.02"
    />
  </svg>
);
export default Goal;
